<template>
  <div id="app">
    <the-loading-animation />
    <component v-bind:is="layout"/>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import AppLayout from './layouts/AppLayout'
import SimpleLayout from './layouts/SimpleLayout'
import TheLoadingAnimation from './components/Common/TheLoadingAnimation'
import Cookies from 'js-cookie'

export default {

  components: {
    'app-layout': AppLayout,
    'simple-layout': SimpleLayout,
    TheLoadingAnimation
  },

  computed: {

    layout () {
      return this.$store.getters.layout
    },

    viewname () {
      return this.$store.state.viewname
    },

    menuCollapsed () {
      return this.$store.state.menuCollapsed
    },

    lastname () {
      return this.$store.state.user.userLastname
    },

    firstname () {
      return this.$store.state.user.userFirstname
    },

    remainingfreedays () {
      return this.$store.state.user.remainingfreedays
    },

    name () {
      if (this.$store.state.user.userLastname === '' && this.$store.state.user.userFirstname === '') {
        return this.$store.state.user.userEmail
      }
      if (this.$store.state.user.userLastname === '') {
        return this.$store.state.user.userFirstname
      }
      if (this.$store.state.user.userFirstname === '') {
        return this.$store.state.user.userLastname
      }

      return this.$store.state.user.userFirstname + ' ' + this.$store.state.user.userLastname
    },

    avatar () {
      return this.$store.state.user.userAvatar
    },

    accountId () {
      return this.$store.state.user.accountId
    }

  },

  methods: {
    toggleMenu () {
      this.$store.commit('toggleMenu')
    }
  },

  watch: {
    accountId () {
      if (!this.$store.state.user.accountId) {
        return
      }

      // fetch global tag list as used in various locations
      this.$store.dispatch('tag/getTags')

      this.$echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + Cookies.get('bm-token')

      this.$echo.private('a.' + this.$store.state.user.accountId)
        .listen('BackupFailed', e => {
          this.$store.dispatch('messages/backupFailed', e)
        })
        .listen('BackupFinished', e => {
          this.$store.dispatch('messages/backupFinished', e)
        })
        .listen('BackupProgress', e => {
          this.$store.dispatch('messages/backupProgress', e)
        })
        .listen('BackupStarted', e => {
          this.$store.dispatch('messages/backupStarted', e)
        })
        .listen('BackupTestFinished', e => {
          this.$store.dispatch('messages/backupTestFinished', e)
        })
        .listen('BackupTestStarted', e => {
          this.$store.dispatch('messages/backupTestStarted', e)
        })
        .listen('BackupTestProgress', e => {
          this.$store.dispatch('messages/backupTestProgress', e)
        })
        .listen('BackupAuditStarted', e => {
          this.$store.dispatch('messages/backupAuditStarted', e)
        })
        .listen('BackupAuditFinished', e => {
          this.$store.dispatch('messages/backupAuditFinished', e)
        })
        .listen('BackupAuditProgress', e => {
          this.$store.dispatch('messages/backupAuditProgress', e)
        })
        .listen('CoreUpdateFailed', e => {
          this.$store.dispatch('messages/coreUpdateFailed', e)
        })
        .listen('CoreUpdateProgress', e => {
          this.$store.dispatch('messages/coreUpdateProgress', e)
        })
        .listen('CoreUpdateSuccess', e => {
          this.$store.dispatch('messages/coreUpdateSuccess', e)
        })
        .listen('ExtensionUpdateSuccess', e => {
          this.$store.dispatch('messages/extensionUpdateSuccess', e)
        })
        .listen('ExtensionUpdateFailed', e => {
          this.$store.dispatch('messages/extensionUpdateFailed', e)
        })
        .listen('NewSiteCreated', e => {
          this.$store.dispatch('messages/newSiteCreated', e)
        })
        .listen('SiteDown', e => {
          this.$store.dispatch('messages/siteDown', e)
        })
        .listen('SiteUp', e => {
          this.$store.dispatch('messages/siteUp', e)
        })
        .listen('SiteUpdateSuccess', e => {
          this.$store.dispatch('messages/siteUpdateSuccess', e)
        })
        .listen('SiteUpdateFailed', e => {
          this.$store.dispatch('messages/siteUpdateFailed', e)
        })
    }
  }
}
</script>
